import React from 'react';
import { useRouter } from 'next/router';

import { Paragraph } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import ExpandableDisclaimer from '../../RentalProtection/shared/ExpandableDisclaimer';

const ExpandableDisclaimerWithData = ({
  disclaimerTypes = 'full',
  displaySurplusTaxesAndFees = false,
}: {
  disclaimerTypes?: string;
  displaySurplusTaxesAndFees?: boolean;
}) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: legalDisclaimer } = useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers(
    { listingAlias, disclaimerTypes },
    {
      enabled: Boolean(listingAlias),
      meta: {
        tags: ['rentalProtectionDisclaimers', `rentalProtectionDisclaimers-${listingAlias}`],
        context: {
          api: 'getDisclaimers',
          details: { listingAlias, disclaimerTypes },
        },
      },
    },
  );

  return (
    <div data-testid="ExpandableDisclaimerWithData">
      {displaySurplusTaxesAndFees && (
        <Paragraph textStyle="body-xs" color="text.subtle" css={{ marginBottom: '200' }}>
          *plus applicable surplus lines taxes and fees
        </Paragraph>
      )}

      <ExpandableDisclaimer title="Legal disclaimer" disclaimerContent={legalDisclaimer?.disclaimers || []} />
    </div>
  );
};

export default ExpandableDisclaimerWithData;
